import React from 'react';
import styled from 'packages/theming';
import { Box, Logo, constants } from '@match/react-component-library';

const { SEMANTIC_COLOR_NAME } = constants;

const MobiHeader = () => {
  return (
    <StyledBox
      backgroundColor={SEMANTIC_COLOR_NAME.CORE1_100}
      width="100%"
      height={60}
      position="fixed"
      display="flex"
      center
    >
      <Box width="85%" maxWidth={500}>
        <a href="/">
          <Logo width={50} height={50} size="abbreviated" color={SEMANTIC_COLOR_NAME.LIGHT} />
        </a>
      </Box>
    </StyledBox>
  );
};

export default MobiHeader;

const StyledBox = styled(Box)(() => {
  return {
    zIndex: 1000,
  };
});
